<template>
    <v-sheet rounded color="grey-darken-5" min-width="25" height="20" class="mode-chip">
        <div class="mode-chip__title" v-text="chipTitle"></div>
    </v-sheet>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
    /**
     * The title of the mode chip.
     */
    title?: string;
}

const props = defineProps<Props>();
// const border = computed(() => (!props.color || props.color === 'transparent' || props.color === 'white' ? 'sm' : undefined));
const breakablePrefixes = ['SK', 'FB', 'VY'];
// const showNotificationBadge = computed(() => props.notificationMessages !== undefined && props.notificationMessages?.length > 0);
// const showNotificationDialog = ref(false);
// const shouldNotificationDialogBeAvailable = computed(
//     () => props.notificationMessages !== undefined && props.notificationMessages?.length > 0 && props.activeSummary
// );
// const sortedNotificationMessages = computed(() => [...props.notificationMessages].toSorted(sortBySeverity));

const chipTitle = computed(() => {
    let t = props.title ?? '';
    if (t.length < 4) return t;

    return breakablePrefixes.some(p => t.indexOf(p) === 0) ? `${t.substring(0, 2)} ${t.substring(2)}` : t;
});

// const cssClasses = computed(() => ({
//     'chip-cursor': props.notificationMessages !== undefined && props.notificationMessages?.length > 0 && props.activeSummary
// }));
// const modeChipCssClasses = computed(() => ({
//     'mode-chip--fixed': props.fixedSize,
//     'font-size-sm': props.fixedSize && (props.title?.length ?? 0) === 3,
//     'font-size-xs': props.fixedSize && (props.title?.length ?? 0) === 4,
//     'font-size-xxs': props.fixedSize && (props.title?.length ?? 0) >= 5
// }));
</script>

<style lang="scss">
@use 'vuetify/settings' as *;

.mode-chip {
    --mode-chip-width: 24px;
    --mode-chip-height: 24px;
    --mode-chip-font-size: #{calc(10px / $font-size-root) * 1rem};

    padding: 0 3px;
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    min-height: var(--mode-chip-height);
    min-width: var(--mode-chip-width);
    line-height: var(--mode-chip-font-size);
    font-size: var(--mode-chip-font-size);

    // &.font-size-sm {
    //     --mode-chip-font-size: #{calc(14px / $font-size-root) * 1rem};
    // }

    // &.font-size-xs {
    //     --mode-chip-font-size: #{calc(12px / $font-size-root) * 1rem};
    // }

    // &.font-size-xxs {
    //     --mode-chip-font-size: #{calc(10px / $font-size-root) * 1rem};
    // }

    &__title {
        display: inline-block;
        white-space: nowrap;
        font-weight: bold;

        .mode-chip--fixed & {
            white-space: normal;
            text-align: center;
        }
    }

    &--fixed {
        width: var(--mode-chip-width);
        height: var(--mode-chip-height);
    }

    + .v-badge__badge {
        padding: 0;
    }
}

.chip-cursor {
    cursor: pointer;
}
</style>
